import { render } from "./NewsSingle.vue?vue&type=template&id=4c388971&scoped=true"
import script from "./NewsSingle.vue?vue&type=script&lang=js"
export * from "./NewsSingle.vue?vue&type=script&lang=js"

import "./NewsSingle.vue?vue&type=style&index=0&id=4c388971&scoped=true&lang=scss"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c388971"]])

export default __exports__